import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const externalCarriersAdapter = getAdapter();

const externalCarriersSlice = createSlice({
  name: 'externalCarriers',
  initialState: externalCarriersAdapter.getInitialState(),
  reducers: {
    setExternalCarriers: (state, { payload: { externalCarriers } }) => {
      externalCarriersAdapter.setAll(state, externalCarriers);
    }
  }
});

const selectors = externalCarriersAdapter.getSelectors(({ externalCarriers }) => externalCarriers);

export const getExternalCarriers = state => selectors.selectAll(state);

export const { setExternalCarriers } = externalCarriersSlice.actions;

export default externalCarriersSlice.reducer;
